// extracted by mini-css-extract-plugin
module.exports = {"datagridHeader":"DatagridHeader_datagridHeader__bKCv8","stickyHeader":"DatagridHeader_stickyHeader__XAedH"};